import { Stack } from '@mui/material';

import { SpeechBubble } from '@tbd/life-jsx/SystemIcons';

import { LiftPortalAlert } from '#app/components/LiftPortalAlert.js';
import type {
  LiftPortalAlertProps,
  LiftPortalAlertSeverity,
} from '#app/components/LiftPortalAlert.js';

export default function LiftPortalAlertDemo() {
  return (
    <Stack sx={{ gap: 3 }}>
      <h1>Information banner</h1>

      {(Object.keys(VARIANT_TO_ENTRIES) as LiftPortalAlertSeverity[]).map(
        (variant) => (
          <Stack key={variant} sx={{ gap: 1 }}>
            <h2>{variant}</h2>
            {VARIANT_TO_ENTRIES[variant].map((item) => (
              <LiftPortalAlert
                key={item.message}
                severity={variant}
                {...item}
              />
            ))}
          </Stack>
        )
      )}

      <Stack></Stack>
    </Stack>
  );
}

const successItems = [
  {
    message: 'This is a success message (default icon).',
  },
  {
    message: 'This is a success message (no icon).',
    icon: false,
  },
  {
    message: 'This is a success message with a custom icon.',
    icon: <SpeechBubble />,
  },
  {
    message: 'This is a success message with an action.',
    icon: false,
    action: {
      text: 'Action',
      onClick: () => {
        alert('Success Action clicked');
      },
    },
  },
];

const warningItems = [
  {
    message: 'This is a warning message (default icon).',
  },
  {
    message: 'This is a warning message (no icon).',
    icon: false,
  },
  {
    message: 'This is a warning message with a custom icon.',
    icon: <SpeechBubble />,
  },
  {
    message: 'This is a warning message with an action.',
    icon: false,
    action: {
      text: 'Action',
      onClick: () => {
        alert('Warning Action clicked');
      },
    },
  },
];

const errorItems = [
  {
    message: 'This is an error message (default icon).',
  },
  {
    message: 'This is an error message (no icon).',
    icon: false,
  },
  {
    message: 'This is an error message with a custom icon.',
    icon: <SpeechBubble />,
  },
  {
    message: 'This is an error message with an action.',
    icon: false,
    action: {
      text: 'Action',
      onClick: () => {
        alert('Error Action clicked');
      },
    },
  },
];

const VARIANT_TO_ENTRIES: Record<
  LiftPortalAlertSeverity,
  Omit<LiftPortalAlertProps, 'severity'>[]
> = {
  success: successItems,
  warning: warningItems,
  error: errorItems,
} as const;
